import {
  CalendarCheck,
  Car,
  ClipboardCheck,
  Download,
  Eye,
  Gauge,
  Gift,
  Library,
  ListOrdered,
  MessageSquare,
  Navigation,
  RotateCw,
  Route,
  ScanEye,
  Split,
  SquareParking,
  TrendingUp,
  TriangleAlert,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, navy card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Complete Volumes', icon: Library, featured: true },
  { label: '150 Ready-to-Teach Driving Lessons', icon: CalendarCheck, featured: true },
  { label: '100% Visual', icon: Eye, featured: true },
  { label: 'Beginner to Test-Ready', icon: TrendingUp, featured: true },
  { label: 'Vehicle Control', icon: Gauge },
  { label: 'Mirrors & Observation', icon: ScanEye },
  { label: 'Road Positioning', icon: Navigation },
  { label: 'Junctions & Intersections', icon: Split },
  { label: 'Roundabouts', icon: RotateCw },
  { label: 'Parking & Reversing', icon: SquareParking },
  { label: 'Hazard Awareness', icon: TriangleAlert },
  { label: 'Independent Driving', icon: Car },
  { label: 'Visual Maneuver Breakdowns', icon: Route },
  { label: 'Instructor Cues', icon: MessageSquare },
  { label: 'Common Errors & Corrections', icon: Wrench },
  { label: 'Assessments', icon: ClipboardCheck },
  { label: 'Lesson Progressions', icon: ListOrdered },
  { label: '5 Professional Bonus Guides', icon: Gift },
  { label: 'Immediate Digital Access', icon: Download },
]
